import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
;
import { UiTable } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
import { PERSON_VERIFICATION, PERSON_STATUS } from '../const';
import { api } from 'src/api/config';

function resolveData(data) {
  return data.map(person => {
    const newPerson = {
      ...person,
    };
    let flagClassName = 'is-grey';
    if ((person.verification || 0) !== PERSON_VERIFICATION.Ready) {
      if (person.flag === 0) {
        flagClassName = 'is-info';
      } else if (person.flag > 0) {
        flagClassName = 'is-danger';
      }
    } else {
      newPerson.flag = '-';
    }
    newPerson.flagClassName = flagClassName;

    const statusClassName = 'has-text-grey-medium-dark';
    newPerson.statusClassName = statusClassName;

    return newPerson;
  });
}

export function PeopleTable({
  people,
  showActionsDropdown,
  loading,
  paging,
  accountId,
  onDeletePerson,
  onRunBackgroundChecks,
  onResetPassword,
  onSendInvite,
  hideNoDataComponent,
  onApprove,
  onDeny,
  ...props
}) {
  const canPersonCheckApproveDeny = personStatus => {
    return (
      [
        PERSON_STATUS.Submitted,
        PERSON_STATUS.Approved,
        PERSON_STATUS.Denied,
      ].indexOf(personStatus) > -1
    );
  };

  /* eslint-disable react/prop-types */
  const tableColumns = useMemo(() => {
    const result = [
      {
        Header: () => (
          <span className="icon is-small table-header-member-icon">
            <FontAwesomeIcon icon={['fas', 'user-circle']} size="2x" />
          </span>
        ),
        Cell: ({ original }) => (
          <div className={`person-status ${original.statusClassName}`}>
            <span className="icon">
              <FontAwesomeIcon icon={['fas', 'user-circle']} size="2x" />
              {original.isAdmin && (
                <span className="icon-tag">
                  <FontAwesomeIcon icon={['fas', 'star']} />
                </span>
              )}
            </span>
          </div>
        ),
        sortable: false,
        width: 65,
        resizable: false,
      },
      {
        Header: 'Person',
        accessor: 'name',
        Cell: ({ original, value }) => (
          <div className="member-name">
            <div>
              <Link className="edit-link" to={`/people/edit/${original.id}`}>
                {value}
              </Link>
              {original.isSigner && (
                <span className="icon is-small has-text-grey">
                  <FontAwesomeIcon icon={['far', 'signature']} />
                </span>
              )}
            </div>
            <small className="has-text-grey-medium-dark">
              {original.title && `${original.title} | `}
              {original.emailAddress}
            </small>
          </div>
        ),
      },

      {
        Header: 'Type',
        accessor: 'type',
        Cell: row => (
          <small className="has-text-grey-medium-dark is-block has-text-centered">
            {row.value}
          </small>
        ),
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: row => (
          <div className="has-text-centered">{PERSON_STATUS[row.value]}</div>
        ),
        width: 150,
      },
      {
        Header: () => (
          <span className="icon is-small has-text-grey">
            <FontAwesomeIcon icon={['fas', 'pennant']} />
          </span>
        ),
        accessor: 'flag',
        Cell: row => (
          <span className={`flag-badge ${row.original.flagClassName}`}>
            {row.value}
          </span>
        ),
        resizable: false,
        width: 45,
      },
      {
        Header: 'Verify',
        accessor: 'verification',
        Cell: row => (
          <div className="has-text-centered">
            {row.value != null &&
              PERSON_VERIFICATION[row.value] !== 'Ready' &&
              row.original.bgReport !== null && (
                <a
                  href={row.original.bgReport}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {PERSON_VERIFICATION[row.value]}
                </a>
              )}
            {row.value != null &&
              PERSON_VERIFICATION[row.value] === 'Processing' &&
              row.original.bgReport === null &&
              PERSON_VERIFICATION[row.value]}
            {row.value != null &&
              PERSON_VERIFICATION[row.value] === 'Completed' &&
              row.original.bgReport === null && (
                <a
                  href={`${api.hostname}/api/v1/accounts/${accountId}/users/${row.original.id}/background_check_report/`}
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {row.value != null ? PERSON_VERIFICATION[row.value] : ''}
                </a>
              )}
            {row.value == null ||
              (PERSON_VERIFICATION[row.value] === 'Ready' &&
                (row.value != null ? PERSON_VERIFICATION[row.value] : ''))}
          </div>
        ),
        width: 150,
      },
    ];

    if (showActionsDropdown) {
      result.push({
        Header: '',
        accessor: 'id',
        sortable: false,
        width: 62,
        resizable: false,
        Cell: row => (
          <MuiDropdown
            isAlign="right"
            renderTrigger={
              <Button isColor="white">
                <span className="icon">
                  <FontAwesomeIcon
                    icon={['fal', 'ellipsis-v']}
                    className="has-text-grey"
                    size="lg"
                  />
                </span>
              </Button>
            }
          >
              {onRunBackgroundChecks &&
                canPersonCheckApproveDeny(row.original.status) &&
                row.original.isBgConsentSigned && (
                  <MuiDropdownItem
                    tag="a"
                    onClick={() => onRunBackgroundChecks(row.original)}
                  >
                    Verify
                  </MuiDropdownItem>
                )}
              {onApprove && canPersonCheckApproveDeny(row.original.status) && (
                <MuiDropdownItem tag="a" onClick={() => onApprove(row.original)}>
                  Approve
                </MuiDropdownItem>
              )}
              {onDeny && canPersonCheckApproveDeny(row.original.status) && (
                <MuiDropdownItem tag="a" onClick={() => onDeny(row.original)}>
                  Deny
                </MuiDropdownItem>
              )}
              <MuiDropdownItem tag={NavLink} to={`/people/edit/${row.value}`}>
                Edit
              </MuiDropdownItem>
              {onResetPassword && (
                <MuiDropdownItem
                  tag="a"
                  onClick={() => onResetPassword(row.original)}
                >
                  Reset password
                </MuiDropdownItem>
              )}
              {onSendInvite && (
                <MuiDropdownItem
                  tag="a"
                  onClick={() => onSendInvite(row.original)}
                >
                  Send invite
                </MuiDropdownItem>
              )}
              <MuiDropdownItem
                tag="a"
                onClick={() => onDeletePerson(row.original)}
              >
                Archive
              </MuiDropdownItem>
              <hr style={{ margin: '4px 0', borderTop: '1px solid rgba(0, 0, 0, 0.12)' }} />
              {row.original.isBgConsentSigned && (
                <MuiDropdownItem
                  tag="a"
                  href={row.original.bgConsent}
                  target="new"
                >
                  BG Consent
                </MuiDropdownItem>
              )}
              {row.original.isNdaSigned && (
                <MuiDropdownItem tag="a" href={row.original.nda} target="new">
                  NDA
                </MuiDropdownItem>
              )}
          </MuiDropdown>
        ),
      });
    }

    return result;
  }, [showActionsDropdown, onDeletePerson]);
  /* eslint-enable */

  return (
    <UiTable
      className="people-table"
      columns={tableColumns}
      getTheadThProps={(_state, _rowInfo, column) => ({
        className: column.id === 'name' ? 'has-text-left' : '',
      })}
      loading={loading}
      data={people}
      paging={paging}
      title="Person"
      {...props}
      resolveData={resolveData}
      toNext="/vendors"
      toPrev="/locations"
      hidePrev={false}
      hideNext={false}
      hideNoDataComponent={hideNoDataComponent}
    />
  );
}

PeopleTable.defaultProps = {
  showActionsDropdown: false,
  loading: false,
  onDeletePerson: () => {},
  onRunBackgroundChecks: null,
  onResetPassword: null,
  onSendInvite: null,
  hideNoDataComponent: false,
  onApprove: null,
  onDeny: null,
};

PeopleTable.propTypes = {
  showActionsDropdown: propTypes.bool,
  loading: propTypes.bool,
  people: propTypes.array.isRequired,
  accountId: propTypes.number,
  onDeletePerson: propTypes.func,
  onRunBackgroundChecks: propTypes.func,
  onResetPassword: propTypes.func,
  onSendInvite: propTypes.func,
  paging: propTypes.object.isRequired,
  hideNoDataComponent: propTypes.bool,
  onApprove: propTypes.func,
  onDeny: propTypes.func,
};
